<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>运营工具</el-breadcrumb-item>
      <el-breadcrumb-item>短信记录</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
        >
          <el-form-item label="日期" prop="date">
            <el-date-picker
              style="width: 360px"
              v-model="filter.date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div class="mt-10">
          <el-button type="primary" size="small" @click="requestSmsRecord()"
            >筛选</el-button
          >
          <el-button size="small" @click="reset()">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <el-table :data="records" v-loading="loading">
        <el-table-column label="发送对象" width="150px">
          <template slot-scope="scope">
            {{ scope.row.user.name }} {{ scope.row.mobile }}
          </template>
        </el-table-column>
        <el-table-column label="内容" align="center">
          <template slot-scope="scope">
            {{ scope.row.content }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100px" align="center">
          <template slot-scope="scope">
            <status-tag
              :type="SMSStatusMap[scope.row.status].type"
              :name="SMSStatusMap[scope.row.status].name"
            ></status-tag>
          </template>
        </el-table-column>
        <el-table-column label="发送日期" width="150px" align="center">
          <template slot-scope="scope">
            <span>
              {{ formatTime(scope.row.created_at, 'YYYY-MM-DD HH:mm') }}
            </span>
          </template></el-table-column
        ></el-table
      >
      <div class="mt-20">
        <el-pagination
          class="mt-20"
          :page-size="filter.size"
          :current-page.sync="filter.page"
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { smsRecords } from '../../service/getData'
import { formatTime, clone } from '@/util/index'
import { SMSStatusMap } from '../../config/global'
export default {
  name: 'sms_records',
  data() {
    return {
      SMSStatusMap,
      records: [],
      formatTime,
      loading: false,
      total: 0,
      filter: {
        page: 1,
        date: null,
        status: 0,
        size: 20,
      },
    }
  },
  watch: {
    'filter.page': function () {
      this.requestSmsRecord()
    },
  },
  created() {
    this.filter = {
      page: parseInt(this.$route.query.page || 1),
      size: parseInt(this.$route.query.size || 20),
      status: parseInt(this.$route.query.status) || 0,
    }
    this.requestSmsRecord()
  },
  methods: {
    async requestSmsRecord() {
      this.$router.replace({
        query: this.filter,
      })

      this.loading = true
      let query = clone(this.filter)
      query.page = query.page - 1

      if (query.date && query.date.length == 2) {
        query.start_date = query.date[0] || ''
        query.end_date = query.date[1] || ''
      }

      let res = await smsRecords(query)
      if (res.code == 0) {
        this.records = res.data.list
      }
      this.loading = false
    },
    reset() {
      this.filter = {
        page: 1,
        size: 20,
        status: 0,
      }
      this.requestSmsRecord()
    },
  },
}
</script>